import React from "react";
import withIconComponent from "../withIconComponent";

var Hamburger = function Hamburger() {
  return /*#__PURE__*/React.createElement("g", {
    className: "nc-icon-wrapper",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "square",
    strokeWidth: "2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 12h22",
    "data-color": "color-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 5h22M1 19h22"
  }));
};

export default withIconComponent("UiHamburger", false)(Hamburger);